import React from 'react';
import { Box } from '@mui/material';
import { OrgTransactionsData as OrgTransactionsData } from '../../../models/RevShareData';
import ExportButtons from '../components/ExportButtons';
import PeriodLabel from '../components/PeriodLabel';
import TransactionsTableHeader from '../components/TransactionsTableHeader';
import { PricebookTable, pricebookHeaders } from './PricebookTable';
import { TransactionsTableProps } from '../Transactions';
import TransactionsSkeleton from '../components/TransactionsSkeleton';
import { AmountPaidTotal, RevShareTotal } from '../components/TransactionsTotalsLabels';

interface OrgTransactionsTableProps extends TransactionsTableProps {
  data: OrgTransactionsData | undefined;
}

const OrgTransactionsTable: React.FC<OrgTransactionsTableProps> = ({
  data,
  startDate,
  endDate,
  onExportPdf,
  emptyStateText,
  loading,
}) => {
  return (
    <Box>
      <TransactionsTableHeader
        headers={pricebookHeaders}
        totals={{
          amountPaid: <AmountPaidTotal total={data?.subscriptionTotalAmount ?? 0} />,
          revShareAmount: <RevShareTotal total={data?.revShareTotalAmount ?? 0} />,
        }}
      />

      {loading ? (
        <TransactionsSkeleton />
      ) : (
        <PricebookTable
          data={data?.pricebookInfos ?? []}
          leftElement={<PeriodLabel start={startDate} end={endDate} variant='p18SemiBold' />}
          rightElement={<ExportButtons start={endDate} end={endDate} onExportPdf={onExportPdf} />}
          headers={pricebookHeaders}
          emptyStateText={emptyStateText}
        />
      )}
    </Box>
  );
};

export default OrgTransactionsTable;
